export default [
  {
    path: '/tria',
    component: () => import('@/pages/Tria/Template.vue'),
    children: [
      {
        path: '',
        component: () => import('@/pages/Tria/Index.vue'),
      },
    ],
  },
]
